// Base component
export { BaseMobileMenu, type BaseMobileMenuProps } from './BaseMobileMenu'

// App-specific variants
export { ConferenceMobileMenu } from './variants/ConferenceMobileMenu'
export { GatewayMobileMenu } from './variants/GatewayMobileMenu'
export { ModulesMobileMenu } from './variants/ModulesMobileMenu'
export { PortalMobileMenu } from './variants/PortalMobileMenu'
export { VisionMobileMenu } from './variants/VisionMobileMenu'

// Subcomponents (for custom implementations)
export {
  MobileMenuAccountSection,
  MobileMenuFooter,
  MobileMenuHeader,
  MobileMenuNavigation,
  ProjectsView,
  WorkspacesView,
} from './components'

// Context
export { type MenuView, type MobileMenuContextValue, MobileMenuProvider, useMobileMenuContext } from './context'

// Hooks
export { useImageLoaded } from './hooks'

// Types
export { AppVariant } from '../../enums'
export type { MobileMenuProps } from './MobileMenu.types'

// Legacy export for backwards compatibility
export { MobileMenu } from './MobileMenu'
